import styled from "styled-components";
import propTypes from "@styled-system/prop-types";
import { space, typography } from "styled-system";
import { badgeColors, badgeStyles } from "../../../themes/customVariant";
import ButtonStyle from "../button/button.style";

const BadgeStyle = styled.span`
  display: inline-block;
  padding: 3px 6px;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  // Empty badges collapse automatically
  &:empty {
    display: none;
  }
  
  ${ButtonStyle} & {
    position: relative;
    top: -1px;
  }
  
  /* Style system support */
  ${space}
  ${typography}
  ${badgeColors}
  ${badgeStyles}
`;

BadgeStyle.propTypes = {
  ...propTypes.space,
  ...propTypes.typography,
};

export { BadgeStyle };
